<div class="od-toolbar">
  <label class="od-input" style="width: 248px; max-width: 100%">
    <od-icon name="search"></od-icon>
    <input type="search" [formControl]="buscar" placeholder="Nombre o RIF" aria-label="Buscar por nombre o RIF" autocomplete="off">
  </label>
  <label class="od-select">
    <span>Estado:</span>
    <select aria-label="Filtrar por estado" (change)="elegirEstado($any($event.target).value)">
      <option *ngFor="let e of estados; trackBy: porValor" [value]="e.valor" [selected]="filtro.estado === e.valor">{{ e.texto }}</option>
    </select>
  </label>
</div>

<!-- Cifras de comercios: tocar una filtra la lista (igual que el select Estado) -->
<div class="od-cd od-kstrip" *ngIf="conteos$ | async as k">
  <button type="button" [attr.aria-pressed]="!filtro.estado" (click)="elegirEstado('')"><span>Total</span><b>{{ numero(total(k)) }}</b></button>
  <button type="button" [attr.aria-pressed]="filtro.estado === 'anotado'" (click)="elegirEstado('anotado')"><span>Anotados</span><b>{{ numero(k.anotados) }}</b></button>
  <button type="button" [attr.aria-pressed]="filtro.estado === 'esperando'" (click)="elegirEstado('esperando')"><span>Esperando envío</span><b>{{ numero(k.pendientes) }}</b></button>
  <button type="button" [class.od-k-mal]="k.errores > 0" [attr.aria-pressed]="filtro.estado === 'problema'" (click)="elegirEstado('problema')"><span>Con problema</span><b>{{ numero(k.errores) }}</b></button>
</div>

<ng-container *ngIf="lista$ | async as v">
  <div class="od-alert" role="alert" *ngIf="v.error">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx"><b>No se pudo traer la lista de comercios</b><div class="od-muted">{{ v.error }}</div></div>
    <button type="button" class="od-btn" (click)="recargar()"><od-icon name="refresh"></od-icon>Reintentar</button>
  </div>

  <div *ngIf="v.cargando && !v.datos" aria-busy="true" aria-label="Cargando comercios">
    <div class="od-skeleton" style="height: 38px; margin-bottom: 6px"></div>
    <div class="od-skeleton" style="height: 40px; margin-bottom: 6px" *ngFor="let i of esperaSkeleton; trackBy: porIndice"></div>
  </div>

  <ng-container *ngIf="v.datos as pag">
    <div class="od-empty od-card" *ngIf="!pag.items.length">
      <od-icon name="store" [size]="22"></od-icon>
      <b>{{ filtro.q || filtro.estado ? 'Ningún comercio coincide' : 'Todavía no hay comercios anotados' }}</b>
      <span>{{ filtro.q || filtro.estado ? 'Cambia la búsqueda o el filtro.' : 'Aparecen aquí cuando se avisa un comercio a Odoo.' }}</span>
    </div>

    <div class="od-table-wrap" *ngIf="pag.items.length" [style.opacity]="v.cargando ? .6 : 1">
      <table class="od-table">
        <caption style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Comercios que se anotan en Odoo. Toca una fila para ver su detalle.</caption>
        <thead>
          <tr>
            <th scope="col">Comercio</th><th scope="col">RIF</th><th scope="col">Código</th><th scope="col">Tiendas</th>
            <th scope="col">Estado en Odoo</th><th scope="col">Último envío</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of pag.items; trackBy: trackFila" class="od-row-click" tabindex="0"
              [class.od-row-sel]="seleccionado?.source_id === f.source_id"
              (click)="elegir(f)" (keydown.enter)="elegir(f)" (keydown.space)="elegir(f); $event.preventDefault()">
            <td>{{ f.nombre || '—' }}</td>
            <td class="od-mono">{{ f.identificacion | odooRif }}</td>
            <td class="od-mono">{{ f.source_id }}</td>
            <td>{{ f.tiendas }}</td>
            <td>
              <span class="od-badge od-badge-solid" *ngIf="f.estado_ui === 'anotado'"><od-icon name="check"></od-icon>Anotado</span>
              <span class="od-badge" *ngIf="f.estado_ui === 'esperando'"><od-icon name="clock"></od-icon>Esperando envío</span>
              <span class="od-badge od-badge-problem" *ngIf="f.estado_ui === 'problema'"><od-icon name="alert"></od-icon>Con problema</span>
            </td>
            <td>
              <ng-container [ngSwitch]="f.estado_ui">
                <span *ngSwitchCase="'esperando'">Se reintenta {{ f.proximo_reintento | odooHoraSola }}</span>
                <span *ngSwitchCase="'problema'">{{ f.motivo }}</span>
                <span *ngSwitchDefault>{{ f.fe_ultimo_envio | odooFechaCorta }}</span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <od-paginador [page]="pag.page" [limit]="pag.limit" [total]="pag.total" unidad="comercios" (cambiar)="pagina($event)"></od-paginador>
  </ng-container>
</ng-container>

<p class="od-note">Los comercios entran en Odoo con el rol «Comercio», nunca como proveedor. Los proveedores (por ejemplo, ekiipago) los registra Contabilidad directamente en Odoo.</p>

<!-- Panel lateral -->
<od-sheet [abierto]="!!seleccionado" [titulo]="limpiar(seleccionado?.nombre) || 'Comercio'" [subtitulo]="(seleccionado?.identificacion | odooRif) || ''" (cerrar)="cerrar()">
  <div od-sheet-acciones *ngIf="seleccionado as a">
    <span class="od-badge od-badge-solid" *ngIf="a.estado_ui === 'anotado'"><od-icon name="check"></od-icon>Anotado</span>
    <span class="od-badge" *ngIf="a.estado_ui === 'esperando'"><od-icon name="clock"></od-icon>Esperando envío</span>
    <span class="od-badge od-badge-problem" *ngIf="a.estado_ui === 'problema'"><od-icon name="alert"></od-icon>Con problema</span>
  </div>
  <ng-container *ngIf="seleccionado as c">
    <div class="od-tabs" role="tablist" aria-label="Datos del comercio">
      <button type="button" class="od-tab" role="tab" [attr.aria-selected]="pestanaSheet === 'detalle'" (click)="pestanaSheet = 'detalle'">Detalle</button>
      <button type="button" class="od-tab" role="tab" [attr.aria-selected]="pestanaSheet === 'historial'" (click)="pestanaSheet = 'historial'">Historial</button>
    </div>

    <ng-container *ngIf="pestanaSheet === 'detalle'">
      <div class="od-alert od-alert-mal" role="alert" *ngIf="c.estado_ui === 'problema' && c.motivo"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx">{{ c.motivo }}</div></div>

      <div class="od-cd od-trio">
        <div><span>Código en Odoo</span><b>{{ c.odoo_id ?? '—' }}</b></div>
        <div><span>Anotado el</span><b>{{ c.fe_alta | odooDiaLargo }}</b><small>{{ c.fe_alta | odooHoraSola }}</small></div>
        <div><span>Último envío</span><b>{{ c.fe_ultimo_envio | odooDiaLargo }}</b><small>{{ c.fe_ultimo_envio | odooHoraSola }}</small></div>
      </div>

      <section class="od-cd">
        <div class="od-cd-h"><h5>Datos en Odoo</h5></div>
        <dl class="od-rows">
          <div><dt>RIF</dt><dd class="od-mono">{{ c.identificacion | odooRif }}</dd></div>
          <div><dt>Código</dt><dd class="od-mono">{{ c.source_id }}</dd></div>
          <div><dt>Tiendas</dt><dd>{{ c.tiendas }}</dd></div>
        </dl>
      </section>

      <section class="od-cd">
        <div class="od-cd-h">
          <h5>Últimos movimientos</h5>
          <button type="button" class="od-link" (click)="verTodo()">Ver todo el historial</button>
        </div>
        <ng-container *ngIf="(movs$ | async) as m">
          <div class="od-cd-b" *ngIf="m.cargando && !m.datos" aria-busy="true"><div class="od-skeleton" style="height: 32px; margin-top: 6px" *ngFor="let i of [0, 1]; trackBy: porIndice"></div></div>
          <div class="od-cd-b"><div class="od-alert od-alert-mal" role="alert" *ngIf="m.error"><div class="od-alert-tx">{{ m.error }}</div></div></div>
          <div class="od-cd-b" *ngIf="m.datos && !m.datos.length"><span class="od-muted">Sin movimientos todavía</span></div>
          <div class="od-items" *ngIf="m.datos && m.datos.length">
            <div *ngFor="let e of (m.datos | slice: 0 : 5); trackBy: porMov">
              <div class="od-it-tx">{{ e.accion_texto }}<small>{{ e.fecha | odooFechaCorta }} · {{ e.usuario || 'automático' }}</small></div>
              <span class="od-badge od-badge-solid" *ngIf="e.ok"><od-icon name="check"></od-icon>Bien</span>
            <span class="od-badge od-badge-problem" *ngIf="!e.ok"><od-icon name="alert"></od-icon>Con problema</span>
            </div>
          </div>
        </ng-container>
      </section>
    </ng-container>

    <section class="od-cd" *ngIf="pestanaSheet === 'historial'">
      <ng-container *ngIf="(movs$ | async) as m">
        <div class="od-cd-b" *ngIf="m.cargando && !m.datos" aria-busy="true"><div class="od-skeleton" style="height: 32px; margin-top: 6px" *ngFor="let i of [0, 1]; trackBy: porIndice"></div></div>
        <div class="od-cd-b" *ngIf="m.error"><div class="od-alert od-alert-mal" role="alert"><div class="od-alert-tx">{{ m.error }}</div></div></div>
        <div class="od-cd-b" *ngIf="m.datos && !m.datos.length"><span class="od-muted">Sin movimientos todavía</span></div>
        <table class="od-table" *ngIf="m.datos && m.datos.length">
          <caption style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Historial de movimientos del comercio en Odoo.</caption>
          <thead><tr><th scope="col">Fecha y hora</th><th scope="col">Qué pasó</th><th scope="col">Quién</th><th scope="col">Resultado</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let e of m.datos; trackBy: porMov">
              <tr class="od-row-click" tabindex="0" role="button" [attr.aria-expanded]="abierto === e.id" [class.od-row-sel]="abierto === e.id"
                  (click)="alternar(e.id)" (keydown.enter)="alternar(e.id)">
                <td style="white-space: nowrap">{{ e.fecha | odooFechaCorta }}</td>
                <td>{{ e.accion_texto }}<span class="od-muted" *ngIf="!e.ok && e.motivo"> · {{ e.motivo }}</span></td>
                <td>{{ e.usuario || 'automático' }}</td>
                <td>
                  <span class="od-badge od-badge-solid" *ngIf="e.ok"><od-icon name="check"></od-icon>Bien</span>
                  <span class="od-badge od-badge-problem" *ngIf="!e.ok"><od-icon name="alert"></od-icon>Con problema</span>
                </td>
              </tr>
              <tr *ngIf="abierto === e.id"><td colspan="4"><od-evento-detalle [evento]="e" [datos]="e.datos || null"></od-evento-detalle></td></tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
    </section>
  </ng-container>

  <ng-container od-sheet-pie>
    <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEditar && seleccionado" [disabled]="enviando" (click)="reenviar()">
      <od-icon name="refresh"></od-icon>{{ enviando ? 'Enviando…' : 'Volver a enviar a Odoo' }}
    </button>
  </ng-container>
</od-sheet>
